import {LiteUserInfo} from "dataLayer/localStorage/localStorageMember";

export enum EnumUxTypes {
  LINK = "link",
  BUTTON = "button",
  BUTTON_FLOATING = "button_floating",
  BUTTON_BOTTOM_BAR = "button_bottombar",
  BUTTON_TOP_BAR = "button_topbar",
  BUTTON_TOGGLE = "button_toggle",
  ICON = "icon",
  ICON_MENU_ITEM = "icon_menu_item",
  IMAGE = "image",
  LIST_CELL = "list_cell",
  LIST = "list",
  SWIPE = "swipe",
  SCROLL = "scroll",
  TAB = "tab",
  SLIDER = "slider",
  CHECKBOX = "checkbox",
  RADIO = "radio",
  VIDEO = "video",
  SCREEN = "screen",
  MODAL = "modal",
  RATING_ADD = "ratings_add",
  INPUT="input",
  NA="NA"
}

export enum EnumWidgets {
  AD_UNTIL = "ad_unit",
  ADD_LISTING = "add_listing",
  ADD_LISTING_SIMILAR = "add_listing_similar",
  BOTTOM_STICKY = "bottom_sticky",
  CATEGORIES_LIST_ICON = "categories_list_icons",
  CONTACT_US = "contact_US",
  EXPORT_LISTING_OPTIONS = "export_listing_options",
  FILTERS = "filters",
  FILTERS_FACETS = "filters_facets",
  GENERAL_TIPS = "general_tips",
  HEADER = "header",
  HEADER_STICKY = "header_sticky",
  REELS_LIST = "reels_list",
  LISTINGS_CONTINUE_BROWSING = "listings_continue_browsing",
  LISTING_RECENTLY_VIEWED = "listings_recently_viewed",
  LISTING_LATEST_BY_CATEGORY = "listings_latest_by_category",
  LISTING_LOCATION_MAP = "listing_location_and_map",
  LISTING_INFORMATION = "listing_information",
  LISTING_DESCRIPTION = "listing_description",
  LISTING_IMAGE = "listing_image",
  LISTING_TITLE = "listing_title",
  LISTING_PRICE = "listing_price",
  LISTING_CELL = "listing_cell",
  LISTING_LEADS = "listing_leads",
  LISTER_OVERVIEW = "lister_overview",
  LISTER_MEMBER_OPENSOOQ_LINK = "lister_member_opensooq_link",
  LISTING_SIMILAR = "listings_similar",
  LISTING_RECOMMENDED = "listings_recommended",
  LISTING_QUALITY_SCORE = "listing_quality_score",
  LISTING_STATISTICS = "listing_statistics",
  LISTING_DETAILS = "listing_details",
  NAVIGATION_BOTTOM_BAR = "navigation_bottom_bar",
  RESULTS_HEADER = "results_header",
  RATING_ADD = "ratings_add",
  RATING_SUMMARY = "ratings_summary",
  RATING_BADGES = "ratings_badges",
  RATING_REVIEWS = "ratings_reviews",
  PROMOTE_LISTING = "promote_listing",
  SPOTLIGHT_BOTTUN = "spotlight_button",
  SHARE_LISTING_OPTIONS = "share_listing_options",
  SHARE_DIALOG = "share_dialog",
  SEARCH_BAR = "search_bar",
  SLIDERS = "sliders",
  TABS = "tabs",
  WALLET_CELL = "wallet_cell",
  BOTTOM_BAR = "bottom_bar",
  NA="NA",
  ADD_LISTING_CARD = "add_listing_card",
  UPGRADE_ACCOUNT_CARD = "upgrade_account_card",
  MAIN_ACTIONS = "main_actions",
  SHOPS_LIST = "shops_list",
  NO_RESULTS_CARD = "no_results_card",
}

export enum EnumActionNameLevel1 {
  CALL = "call",
  APPLY = "apply",
  ADD = "add",
  VIEW = "view",
  ORDER = "order",
  FAVORITE = "favorite",
  MESSAGE = "message",
  AUTHENTICATE = "authenticate",
  FOLLOW = "follow",
  SEARCHES_SAVE = "searches_save",
  SHARE = "share",
  REPORT = "report",
  RATING = "rating",
  SEARCH = "search",
  SCREEN = "screen",
  PERMISSION = "permission",
  NA = "NA",
  UPGRADE = "upgrade",
}
export enum EnumActionNameLevel2 {
  LOAN = "loan",
  LISTING = "listing",
  CV = "cv",
  MEMBER = "member",
  LISTING_ADD = "listing_add",
  LISTING_REMOVE = "listing_remove",
  ADD = "add",
  REMOVE = "remove",
  SEARCH = "search",
  APP = "app",
  KEYWORD = "keyword",
  TAXONOMY = "taxonomy",
  FILTERS = "filters",
  SIMILAR = "similar",
  LOAD = "load",
  START = "start",
  PRODUCTS = "products",
  COMMON  = "common",
  REGISTER = 'register',
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot_password',
  NOTIFICATION="notification",
  LOCATION = "location",
  BUYER = "buyer",
  SELLER = "seller",
  ACCOUNT = "account",
}

export enum EnumActionNameLevel3 {
  CLICK = "click",
  SUCCESS = "success",
  VIEW = "view",
  SUBMIT = "submit",
  VERIFY = 'verify',
  ALLOW = "allow",
  DENY = "deny",
  SEND = "send",
  IMAGE = "image",
  VIDEO = "video",
  METHOD_CHAT = "method_chat",
  METHOD_SMS = "method_sms",
  METHOD_WHATSAPP = "method_whatsapp",

}

export enum EnumLoggingScreenNames {
  LISTING_VIEW = "listing_view" ,
  LISTING_VIEW_IMAGE_GALLERY = "listing_view_image_gallery",
  SEARCH = "search",
  SEARCH_FILTERS = "search_filters",
  SEARCH_OPTIONS = "search_options",
  MEMBER_VIEW = "member_view" ,
  MEMBER_VIEW_DETAILS = "member_view_details" ,
  DEEPLINK =  "deeplink" ,

  RealEstateForSale = "home_realestateforsale_landing",
  Autos = "home_autos_landing",
  ComputerAndLaptops = "home_computerandlaptops_landing",
  MobileTablet = "home_mobiletablet_landing",
  Motorcycles="home_motorcycles_landing" ,
  Gaming= "home_gaming_landing",
  Electronics="home_electronics_landing",
  Services="home_services_landing",
  HomeAndFurniture="home_homeandfurniture_landing",
  JobsVertical="home_jobsvertical_landing",
  ClothingAndAccessories="home_clothingandaccessories_landing",
  MenFashion="home_menfashion_landing",
  BabyKids="home_babykids_landing",
  Food="home_food_landing",
  EducationAndTraining="home_educationandtraining_landing",
  Animals="home_animals_landing",
  BooksHobbies="home_bookshobbies_landing",
  Sports="home_sports_landing",
  BusinessIndustrial="home_businessindustrial_landing",

  HOME = "home",
  ABOUT_US = "about_us",
  INVITE_FRIENDS = "invite_friends" ,
  CONTACT_US_FORM = "contact_us_form",
  CONTACT_US_FORM_SUCCESS = "contact_us_form_success",
  CONTACT_US_SALES = "contact_us_sales",
  AUTHENTIFICATION = 'authentification',
  AUTHENTICATION_LOGIN = "authentification_login",
  AUTHENTICATION_LOGIN_SUCCESS = "authentification_login_success",
  AUTHENTICATION_LOGIN_FAILURE = "authentification_login_failure",
  AUTHENTICATION_REGISTER  = "authentification_register",
  AUTHENTICATION_REGISTER_SUCCESS = "authentification_register_success",
  AUTHENTICATION_REGISTER_FAILURE = "authentification_register_failure",
  AUTHENTICATION_RESET_PASSWORD = 'authentification_reset_password',
  AUTHENTICATION_RESET_PASSWORD_SUCCESS='authentification_reset_password_success',
  NA="NA",
  SHOPS = "shops",
  SHOPS_LIST = "shops_list",
  SHOP_LISTINGS= "shop_listings",
}
export enum EnumCellType {
  TEXT_ONLY = "textOnly",
  CLASSIC = "classic",
  JOB_OPENING_CARD ="jobOpeningCard",
  CV_CARD = "cvCard",
  NA="NA"
}

export enum EnumGeneratedBy {
  USER = "user",
  USER_SHORTCUT= "user_shortcut",
  SYSTEM = "system",
}
export interface ILoggingAPIBody{
  Geo_user_country?: string,
  Geo_user_city?: string,
  Geo_user_location?: string,
  Geo_app_country?: string,
  Geo_post_country?: string,
  Geo_post_city?: string,
  Geo_post_neighborhood?: string,
  Geo_post_location?: string,

  Tech_device_brand: string,
  Tech_device_model: string,
  Tech_device_screen_resolution: string,
  Tech_device_os: string,
  Tech_device_os_version: string,
  Tech_device_browser: string,
  Tech_device_browser_version: string | number,
  Tech_device_language: string,
  Tech_device_timezone: string,
  Tech_device_user_agent: string,
  Tech_device_cpu_arch: string,
  Tech_http_referrer: string,
  Tech_app_version: string | number,
  Tech_app_language: string,
  Tech_app_platform:string,
  Tech_app_ui_theme: string,
  Tech_connection_type: string,
  Tech_connection_latency: string,
  User_abbucket?: string | number,
  User_member_id?: string | number,
  User_tracking_id?: string | number,
  User_type?: string,
  User_authentication?: string,
  User_target_id?: string | number,
  User_target_type?: string,
  Session_id: string | number,
  Session_search_id: string | number,
  Session_source: string,
  Session_medium: string,
  Session_campaign: string,
  Session_life:  number,
  Session_funnel_source: string,
  Action_screen_name: string,
  Action_screen_name_previous: string,
  Action_widget_name: string ,
  Action_ux_type: string,
  Action_name: string,
  Action_name_lvl2: string,
  Action_name_lvl3: string,
  Action_widget_name_previous: string,
  Action_name_previous: string,
  Action_name_lvl2_previous: string,
  Action_name_lvl3_previous: string,
  Action_listing_id: string | number,
  Action_listing_status: string,
  Action_listing_category: string,
  Action_listing_subcategory: string,
  Action_listing_paid_features: string,
  Action_listing_cell_type: string,
  Action_listing_origin_slot_type: string,
  Action_reference_id: string | number,
  Action_reference_entity: string,
  Action_generated_by: string
}
export interface IUtms {
  utmMedium?: string;
  utmCampaign?: string
  utmSource?: string

}


export interface ILoggingAPIsuccessResposnse {
  "status": true
}
//helpers types
export interface IGetDeviceDetails {
  browserName: string;
  browserVersion: string;
  deviceBrand: string;
  deviceModel: string;
  deviceCpuArch: string;
  deviceLanguage: string;
  deviceOS: string;
  deviceOSVersion: string;
  deviceTimeZone:string
}
export interface INetworkConnection extends NetworkInformation {
  effectiveType:string,
  rtt:string
}

export interface IGetInformationFromCookies {
  source: string;
  sessionId: string;
  trackingId: string;
  userInfo: LiteUserInfo;
  postCountry:string;
  sessionLife:number
}

export enum EnumReferenceEntity {
  MEMBER = "member",
  POST = "post",
  ORDER = "order",
  SAVED_SEARCH = "saved_searches",
  NA="NA"
}
export enum EnumUserTargetType{
  Membership = "membership",
  Free = "free",
  NA="NA"
}


export const HTML_ELEMENTS_CLASSES = [
  "searchFacetsSource",
  "viewMoreBtnSource",
  "homeFacetsSource",
  "megaMenuLogging",
  "moreCategorySource",
  "postListItemSource",
] as const;

export type TypeElementsClasses = typeof HTML_ELEMENTS_CLASSES[number];

export type TypeLoggingSelector = TypeElementsClasses ;
